import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { noop } from '@avcan/utils/function'
import { usePrinting } from './Context'
import * as Tabs from 'components/tabs'
import * as Page from 'components/page'
import DetailSet from './DetailSet'
import Confidence from './Confidence'
import OffSeason from './OffSeason'
import TravelAndTerrainAdvice from './TravelAndTerrainAdvice'
import ProblemSet from './problem'
import { DangerRatings } from './danger'
import styles from './Forecast.module.css'

TabSet.propTypes = {
    onTabChange: PropTypes.func,
}

export default function TabSet({ onTabChange = noop }) {
    const intl = useIntl()
    const dangerRatingsHeader = intl.formatMessage({
        defaultMessage: 'Danger ratings',
        description: 'FX tab header',
    })
    const problemsHeader = intl.formatMessage({
        defaultMessage: 'Problems',
        description: 'FX tab header',
    })
    const detailsHeader = intl.formatMessage({
        defaultMessage: 'Details',
        description: 'FX tab header',
    })

    if (usePrinting()) {
        return (
            <div className={styles.PrintableTabSet}>
                <Page.Section title={dangerRatingsHeader}>
                    <OffSeason />
                    <DangerRatings />
                    <TravelAndTerrainAdvice />
                </Page.Section>
                <Page.Section title={problemsHeader}>
                    <ProblemSet />
                </Page.Section>
                <Page.Section title={detailsHeader}>
                    <DetailSet />
                    <Confidence />
                </Page.Section>
            </div>
        )
    }

    return (
        <Tabs.Container onTabChange={onTabChange}>
            <Tabs.HeaderSet>
                <Tabs.Header>{dangerRatingsHeader}</Tabs.Header>
                <Tabs.Header>{problemsHeader}</Tabs.Header>
                <Tabs.Header>{detailsHeader}</Tabs.Header>
            </Tabs.HeaderSet>
            <Tabs.PanelSet>
                <Tabs.Panel>
                    <OffSeason />
                    <DangerRatings />
                    <TravelAndTerrainAdvice />
                </Tabs.Panel>
                <Tabs.Panel>
                    <ProblemSet />
                </Tabs.Panel>
                <Tabs.Panel>
                    <DetailSet />
                    <Confidence />
                </Tabs.Panel>
            </Tabs.PanelSet>
        </Tabs.Container>
    )
}
